import { render, staticRenderFns } from "./SmsConfiguration.vue?vue&type=template&id=49befa9c"
import script from "./SmsConfiguration.vue?vue&type=script&lang=js"
export * from "./SmsConfiguration.vue?vue&type=script&lang=js"
import style0 from "./SmsConfiguration.vue?vue&type=style&index=0&id=49befa9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports